module.exports = __webpack_public_path__ + "media/images/mailers/linkedin-1dd143a731afb245bf246badbb392d40.png";